import { isDevMode } from '@angular/core';
import { withDevtools, withDevToolsStub } from '@ngrx-toolkit/core';

declare const ngDevMode: boolean | undefined;

/**
 * Connects SignalStore to Redux DevTools only in development mode.
 * Uses `withDevToolsStub` in production to prevent state leakage and enable dead-code elimination.
 */
export const withStoreDevtools: typeof withDevtools = (name, ...features) => {
  const isDev = typeof ngDevMode === 'undefined' ? isDevMode() : !!ngDevMode;
  return isDev ? withDevtools(name, ...features) : withDevToolsStub(name);
};
